import { Locale } from 'ckeditor5';
import { CommentView } from 'ckeditor5-premium-features';
import editButton from '../../assets/editButton.svg?raw';
import resolveIcon from '../../assets/resolveButton.svg?raw';

export default class QualioCommentView extends CommentView {
  static useMultiRootEditor: boolean;

  constructor(locale: Locale, model: any, config: any) {
    super(locale, model as any, config);
    if (!QualioCommentView.useMultiRootEditor) {
      if (model.id !== 'resolved') {
        this.removeButton.set({
          icon: resolveIcon,
          label: '',
          isEnabled: false,
          isVisible: false,
          withText: false,
        });
        this.editButton.set({
          label: 'Edit',
          tooltip: true,
          icon: editButton,
          withText: false,
        });
        this.dropdown.isVisible = false;
        this.actionBar.remove(0);
        this.actionBar.add(this.editButton);
        this.actionBar.add(this.removeButton);
      }
    }
  }

  switchToEditMode = () => {
    super.switchToEditMode();
    const editingView = this.visibleView.get(0) as any;
    editingView?.cancelButtonView.set({
      label: 'Cancel',
      withText: true,
      icon: null,
    });
    editingView?.submitButtonView.set({
      label: 'Save',
      withText: true,
      icon: null,
    });
  };
}

export const qualioCommentViewBuilder = (useMultiRootEditor = false) => {
  QualioCommentView.useMultiRootEditor = useMultiRootEditor;
  return QualioCommentView;
};
